import transportRequest from "./transportFuncs/transportRequest";
import transportError from "./transportFuncs/transportError";

export default {
  mixins: [transportRequest, transportError],
  data() {
    return {
      loading: false,
      scheduled: false
    };
  },
  methods: {

    transport(
      method,
      uri,
      data,
      successCallback,
      errorCallback,
      afterCallback,
      sendBearer = true
    ) {
      return this.transportRequest(method, uri, data, sendBearer)
        .then((response) => {
          successCallback(response);
        })
        .catch((error) => {
          this.transportError(error, errorCallback);
          if(typeof errorCallback === "function"){
            errorCallback(error)
          }
        })
        .then(afterCallback);
    },

    exchange(
      store,
      data,
      uri,
      method = "GET",
      successSnack = null,
      successCallback,
      errorCallback,
      scheduleIfBusy = false
    ) {
      if (this.loading) {
        if (scheduleIfBusy) this.scheduled = arguments;
        return;
      }
      this.loading = true;
      this.transport(
        method,
        uri,
        data,
        (response) => {
          store(response.data);
          if (successSnack) {
            this.successSnack(successSnack);
          }
          if (typeof successCallback === "function") {
            successCallback(response);
          }
        },
        (e)=>{
          this.showSnack();
          if(typeof errorCallback === "function"){
            errorCallback(e)
          }
        },
        () => {
          this.loading = false;
          if (this.scheduled) {
            const sc = [...this.scheduled];
            this.scheduled = false;
            this.exchange(...sc);
          }
        }
      );
    }
  }
};
